import { Box, Button, FlexBox, Icon, Textarea } from '@dixa/lib-shared-habla';

import { useArticleFeedback } from '../../hooks';

import styles from './ArticleFeedback.module.scss';

function FooterButtons() {
  const {
    handleMessageChange,
    onFeedbackSkipped,
    onNegativeReaction,
    onPositiveReaction,
    onSubmit,
    stage,
    values,
  } = useArticleFeedback();

  if (stage === 'error') {
    return <div>There was an error submitting your feedback.</div>;
  }

  if (stage === 'form') {
    return (
      <Box>
        <Box className={styles.textArea}>
          <Textarea
            height={76}
            value={values.feedback}
            placeholder="Please let us know how this article can be improved..."
            onChange={handleMessageChange}
          />
        </Box>
        <FlexBox justifyContent="flex-end" gap="8px">
          <Button variant="secondary" onClick={onFeedbackSkipped}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSubmit}>
            Submit
          </Button>
        </FlexBox>
      </Box>
    );
  }

  // If stage is 'initial' or 'helpfulSubmitting', show buttons
  return (
    <FlexBox justifyContent="space-between">
      {stage === 'helpfulSubmitting' ? (
        <Button
          className={styles.helpfulButtonSubmitted}
          variant="tertiary"
          disabled={true}
        >
          <FlexBox alignItems="center">
            <Icon
              /* eslint-disable @typescript-eslint/ban-ts-comment */
              // @ts-ignore because habla
              size={12}
              name="check-circle-filled"
            />
            &nbsp;Helpful
          </FlexBox>
        </Button>
      ) : (
        <Button variant="primary" onClick={onPositiveReaction}>
          Mark as helpful
        </Button>
      )}
      <Button variant="primary" onClick={onNegativeReaction}>
        Feedback...
      </Button>
    </FlexBox>
  );
}

export function ArticleFeedback(): JSX.Element {
  return (
    <footer className={styles.footer}>
      <FooterButtons />
    </footer>
  );
}
